// Нам приходит заголовок содержащий код региона, код нужно извлечь
// В некоторых случаях код стоит вначале

const checkIsNum = (titleArr: any) => {
  if (Number(titleArr[0])) {
    return titleArr[0];
  }
  const result: any = new Set([...titleArr]);
  return [...result].join(' ');
};
export default checkIsNum;
